import * as util from './util.js'

const currentScript = util.getCurrentScript()

export var CURRENT_LANGUAGE = currentScript && currentScript.getAttribute('data-lang') ? currentScript.getAttribute('data-lang') : 'is'

// if client fails to load translations via ajax, then it reverts to this
export var LANGUAGE_STRINGS = {
  'is': {
    // Step names
    BASIC_INFO: 'Grunnupplýsingar',
    METER_READINGS: 'Álestrar',
    CONTACT_INFO: 'Samskiptaupplýsingar',
    SUMMARY_AND_CONFIRMATION: 'Samantekt & staðfesting',
    REQUEST_READING: 'Óskað eftir álestri',

    // Button labels
    FORWARD: 'Áfram',
    FORWARD_FINISH: 'Senda álestur',
    BACK: 'Til baka',
    CHANGE: 'Breyta',
    SEND: 'Senda',
    FETCHING_DATA: 'Sæki gögn',
    SENDING_DATA: 'Sendi gögn',

    // Step 1
    METER_OWNER_SSN: 'Sláðu inn kennitölu (án bandstriks) þess sem skráður er fyrir mæli',
    INPUT_A_METER_NUMBER: 'Sláðu inn allt númer eins rafmagns- eða hitamælis. ATHUGIÐ að slá EKKI inn stöðu mælis hér',
    SIX_NUMBERS_OR_MORE: '6 tölustafir eða fleiri',
    METER_INPUT_INFOMSG: 'Þetta mælanúmer er til auðkenningar og til að sýna í næsta skrefi aðra mæla sem skráðir eru á kennitöluna á sama heimilisfangi.',
    METER_INPUT_ERROR: 'Kennitalan og mælanúmerið passa ekki saman. Prófaðu kennitölu maka. Upplýsingar um álestra og mæla má finna hér: ',
    METER_INFO_LINK_LABEL: 'Mælar og álestrar',
    METER_INFO_LINK: '//www.veitur.is/spurningar-og-rad/maelar-og-alestrar',

    REGISTERING_READING: 'Skráir þú álestur?',
    YES_I_HAVE_REGISTERED_A_READING: 'Já, það er búið að lesa af og ég vill skrá það hér',
    NO_I_WANT_VEITUR_TO_PERFORM_READING: 'Nei, ég vil að starfsmaður Veitna komi og lesi af',
    TRANSFER_ADDRESS: 'Heimilisfang notendaskipta',
    NOTICE_FEE_WILL_BE_CHARGED: 'Athugið að tekið er gjald vegna komu starfsmanns til að lesa af vegna flutninga.',
    SEE_PRICE_LIST: 'Sjá verðskrá',

    // Step 2
    METER_OVERVIEW: 'Yfirlit mæla',
    METER_OVERVIEW_INSTRUCTIONS: 'Vinsamlegast skráðu inn dagsetningu og stöðu þeirra mæla sem þú vilt skila álestri af',
    ONE_OR_MORE: 'einn eða fleiri.',
    METER_NUMBER: 'Mælanúmer',
    METER_ADDRESS: 'Notkunarstaður',
    METER_TYPE: 'Veitutegund',
    METER_IMAGE: 'Mynd af álestri',
    METER_RETURN: 'Skila álestri',
    UPLOAD_IMAGE: 'Hlaða upp mynd',

    DATE_OF_LAST_READING: 'Síðasti álestur',
    DATE_OF_READING: 'Dagsetning álesturs',
    METER_STATUS: 'Staða mælis',
    EXTRA_READING: 'Eftirlitsálestur án uppgjörsreiknings',
    EXTRA_READING_MSG: 'Einungis er hægt að senda inn eftirlitsálestur án uppgjörs',
    SELECT_METER: 'Velja mæli',
    ATTENTION: 'Athugið',

    ATTENTION_READING_CANNOT_BE_OLDER_THAN_30_DAYS: 'Ath. álesturinn má ekki vera eldri en 30 daga gamall',

    METER_READING_FREQUENCY_MSG: 'Ekki er hægt að senda inn álestur á sama mæli örar en á 28 daga fresti.',
    METER_READING_AGE_MSG: 'Álestur má ekki vera eldri en dagsgamall.',
    METER_READING_EXTRA_READING_MSG: 'Að senda inn eftirlitsálestur hentar einungis þeim sem vilja fylgjast náið með notkun sinn og skrá inn álestra reglulega.',

    EXTRA_READING_WITHOUT_SETTLEMENT: 'Eftirlitsálestur án uppgjörsreiknings:',
    EXTRA_READING_WITHOUT_SETTLEMENT_MSG: 'Mánaðarlegir reikningar byggja á ætlaðri notkun yfir árið sem er dreift jafnt niður á mánuði. Að senda inn „Eftirlitsálestur án uppgjörsreiknings“ er einungis til þess gert að viðskiptavinir geti fylgst með notkun án þess að fá uppgjör. Notkun getur verið mjög sveiflukennd og mánaðarlegir reikningar því misháir sé óskað eftir uppgjöri í hvert sinn sem lesið er af',
    EXTRA_READING_WITHOUT_SETTLEMENT_MSG2: 'Þeir sem skrá reglulega eftirlitsálestur fá engu að síður áminningu um árlegan álestur frá okkur vegna uppgjörs. Þá er ekki hægt að skrá eftirlitsálestur.',

    PLEASE_SELECT_METERS_TO_REGISTER: 'Vinsamlegast veldu þá mæla sem þú vilt tilkynna notendaskipti á og sláðu inn stöðu',

    READING_INPUT_ERRORS_MSG: 'Einn eða fleiri álestrar sem þú hefur slegið inn gefa til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. Athugaðu hvort þú hafir slegið inn réttar tölur',
    CONTINUE_IF_YOU_ARE_SURE: 'Ef þú ert alveg viss getur þú smellt á „Áfram“ og klárað tilkynninguna.',

    // Step 2b
    I_REQUEST_THAT_VEITUR_PERFORMS_THE_READING: 'Ég óska þess að starfsfólk Veitna komi og lesi af',
    NAME_THE_ADDDRESS_OR_METER_MSG: 'Tilgreindu þá staði eða mælanúmer sem flutningurinn á við. Dæmi: Íbúð 201 eða bílskúr nr. 2.',
    IN_THE_NEXT_STEP_MSG: 'Í næsta skrefi skráir þú upplýsingar um þann sem flytur inn.',

    // Step 3
    YOUR_NAME: 'Nafnið þitt',
    YOUR_EMAIL: 'Netfangið þitt',
    YOUR_PHONE_NUMBER: 'Símanúmerið þitt',

    THE_ONE_MOVING_OUT: 'Sá sem flytur út:',
    THE_ONE_MOVING_IN: 'Sá sem tekur við:',
    OTHER: 'Annar',

    SSN_OF_THE_ONE_WHO_TAKES_OVER_THE_METERS: 'Kennitala þess sem tekur við mælum',
    YOUR_SSN: 'Kennitalan þín',
    MAILING_ADDRESS: 'Heimilisfang þar sem póstur á að berast',
    POSTAL_CODE_PLACE: 'Póstnúmer / Staður',
    OK: 'OK',

    // Payment
    METHOD_OF_PAYMENT: 'Greiðslumáti',
    NET_PAYMENT: 'Netgreiðslur (kröfur birtast eingöngu í heimabanka)', // webpayments?
    DEPOSIT_SLIP: 'Greiðsluseðill', // google translate
    DIRECT_PAYMENT: 'Beingreiðslur (þjónusta sem bankar bjóða viðskiptavinum sínum)',
    CREDIT_CARD: 'Kreditkort',

    CARD_HOLDERS_NAME: 'Nafn korthafa',
    CARD_NUMBER: 'Kortanúmer',
    CARD_EXPIRATION_DATE: 'Gildistími (mán / ár)',

    // Step 4
    YOU_HAVE_REGISTERED_THE_FOLLOWING_METERS: 'Þú hefur skráð upplýsingar um stöðu eftirtaldra mæla',
    TYPE_OF_READING_LABEL: 'Tegund álestrar',
    OTHER_INFO: 'Aðrar upplýsingar:',
    WHO_IS_REPORTING: 'Sá sem tilkynnir',
    READING_HISTORY: 'Álestrarsaga',
    READING_HISTORY_MSG: 'Þú getur fengið yfirlit yfir álestra á þínum mælum hér á',
    MY_PAGES: 'Mínum síðum',
    SUBMIT_FAILED: 'Því miður tókst ekki að senda inn álestur',
    SUBMIT_RECEIVED: 'Álestur móttekinn',
    YOU_HAVE_REQUESTED_A_READING_FROM_VEITUR: 'Þú hefur óskað eftir að starfsmaður komi og lesi af',
    DATE: 'Dagsetning',

    SSN: 'Kennitala',
    NAME: 'Nafn',
    EMAIL_ADDRESS: 'Netfang',
    PHONE_NUMBER: 'Símanúmer',
    ADDRESS: 'Heimilisfang',

    TRANSFER_REQUEST_RECEIVED: 'Flutningstilkynning móttekinn',
    COMMENTS: 'Athugasemdir',

    ALERTS: {
      'INVALID_FIELDS': 'Einhverjir reitir eru ekki rétt útfylltir \n\n',
      'EMPTY_FIELDS': 'Vantar að fylla út nauðsynlega reiti \n\n',
      'INVALID_RANGE': 'Einn eða fleiri álestrar utan viðmiðunarmarka. Athugið hvort rétt gildi hafi verið slegið inn\n\n',
      'INVALID_DATE': '',
      'INSTRUCTIONS': 'Ýttu á OK til að halda áfram eða Cancel til að hætta við',
      'NO_METERS_SELECTED': 'Engir mælar valdir',
      'INVALID_PAYMENT_INFO': 'Veldu greiðslumáta',
      'INVALID_CREDIT_CARD_INFO': 'Vinsamlegast fylltu út kortaupplýsingar',
      'INVALID_CREDIT_CARD_EXPIRATION_DATE': 'Athugaðu hvort gildistími kreditkorts sé réttur',
      'INVALID_AGE': 'Lágmarksaldur til að taka við mælum er 18 ár',
      'INVALID_ALESTUR': 'Einn eða fleiri álestrar sem þú hefur slegið inn gefa til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. Athugaðu hvort þú hafir slegið inn réttar tölur.\n \n Ef þú ert alveg viss getur þú smellt á „Áfram“ og klárað tilkynninguna.',
      'SELECT_AT_LEAST_ONE': 'Veldu a.m.k. einn mæli'
    },

    TOOLTIP_MSG: {
      'oneDecimal': 'einum aukastaf',
      'decimals': ' aukastöfum',
      'inputReadingWith': 'Sláðu álesturinn inn með ',
      'inputWithOutDecimals': 'Sláðu álesturinn inn án aukastafa (enga kommu).',
      'readingOutOfRange': 'Þessi álestur gefur til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. ',
      'checkIfCorrectInput': 'Athugaðu hvort þú hafir slegið inn réttar tölur.'
    },

    TYPE_OF_READING: {
      'extraReading': 'Eftirlitsálestur',
      'settelmentReading': 'Uppgjör'
    },

    VEITUKERFI: {
      'R': 'Rafmagn',
      'H': 'Hiti',
      'K': 'Kalt vatn'
    }
  }
}

export var TOOLTIP_MSG = {
  'is': {
    oneDecimal: 'einum aukastaf',
    decimals: ' aukastöfum',
    inputReadingWith: 'Sláðu álesturinn inn með ',
    inputWithOutDecimals: 'Sláðu álesturinn inn án aukastafa (enga kommu).',
    readingOutOfRange: 'Þessi álestur gefur til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. ',
    checkIfCorrectInput: 'Athugaðu hvort þú hafir slegið inn réttar tölur.'
  }
}

export var TYPE_OF_READING = {
  'is': {
    extraReading: 'Eftirlitsálestur',
    settelmentReading: 'Uppgjör'
  }
}

export var ALERTS = {
  'is': {
    INVALID_FIELDS: 'Einhverjir reitir eru ekki rétt útfylltir \n\n',
    EMPTY_FIELDS: 'Vantar að fylla út nauðsynlega reiti \n\n',
    INVALID_RANGE: 'Einn eða fleiri álestrar utan viðmiðunarmarka. Athugið hvort rétt gildi hafi verið slegið inn\n\n',
    INVALID_DATE: '',
    INSTRUCTIONS: 'Ýttu á OK til að halda áfram eða Cancel til að hætta við',
    NO_METERS_SELECTED: 'Engir mælar valdir',
    INVALID_PAYMENT_INFO: 'Veldu greiðslumáta',
    INVALID_CREDIT_CARD_INFO: 'Vinsamlegast fylltu út kortaupplýsingar',
    INVALID_CREDIT_CARD_EXPIRATION_DATE: 'Athugaðu hvort gildistími kreditkorts sé réttur',
    INVALID_AGE: 'Lágmarksaldur til að taka við mælum er 18 ár',
    INVALID_ALESTUR: 'Einn eða fleiri álestrar sem þú hefur slegið inn gefa til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. Athugaðu hvort þú hafir slegið inn réttar tölur.\n \n Ef þú ert alveg viss getur þú smellt á „Áfram“ og klárað tilkynninguna.',
    SELECT_AT_LEAST_ONE: 'Veldu a.m.k. einn mæli'
  }
}

export var VEITUKERFI = {
  'is': {
    'R': 'Rafmagn',
    'H': 'Hiti',
    'K': 'Kalt vatn'
  }
}



// WEBPACK FOOTER //
// ./src/lib/translations.js